// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/main.less
// module id = 2280
// module chunks = 0